import React, { useRef } from 'react';
import HeroCard from './HeroCard';
import StatsRow from './StatsRow';
import LanguageChart from './LanguageChart';
import TopRepos from './TopRepos';
import Timeline from './Timeline';
import SharePanel from './SharePanel';
import './StoryPage.css';

export default function StoryPage({ data, onBack }) {
  const storyRef = useRef(null);
  const { user, topLangs, topRepos, yearsActive, activeDays, commitCount, repos } = data;

  return (
    <div className="story">
      <div className="story__noise" aria-hidden="true" />

      <nav className="story__nav">
        <button className="story__back" onClick={onBack}>
          ← Back
        </button>
        <span className="story__nav-label">
          <span className="story__nav-dot" />
          {user.login}'s story
        </span>
        <SharePanel username={user.login} storyRef={storyRef} />
      </nav>

      <div className="story__content" ref={storyRef}>
        <HeroCard user={user} yearsActive={yearsActive} />

        <StatsRow
          followers={user.followers}
          repos={user.public_repos}
          activeDays={activeDays}
          commitCount={commitCount}
        />

        <div className="story__row">
          <LanguageChart langs={topLangs} />
          <Timeline user={user} repos={repos} />
        </div>

        <TopRepos repos={topRepos} />

        <footer className="story__footer">
          <span className="story__footer-credit">
            Generated by <span>GitHub Story Builder</span> · by Agus Satria Adhitama
          </span>
          <a
            href={`https://github.com/${user.login}`}
            target="_blank"
            rel="noreferrer"
            className="story__footer-link"
          >
            github.com/{user.login} ↗
          </a>
        </footer>
      </div>
    </div>
  );
}
